import { styled } from '@linaria/react'
import { TextBoxSC } from 'atoms/TextBox'
import { COLOR } from 'vars/color'

export const EpgSidebarBodySC = styled.div`
  --paddingBodyBlock: 28px;
  --paddingRight: 56px;
  --scrollbarOffset: 8px;
  display: flex;
  flex-direction: column;
  flex: 1 0;
  overflow: auto;
  overscroll-behavior: none;

  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: var(${COLOR.SURFACE_OPACITY_LIGHT_10});
    border-radius: 2px;
    cursor: pointer;
  }
`

export const EpgSidebarProgramInfoSC = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  padding: var(--paddingBodyBlock) var(--paddingRight);
  + ${TextBoxSC} {
    padding: 0 var(--paddingRight);
  }
`

export const ProgramEpgList = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  padding: var(--paddingBodyBlock) var(--paddingRight);
`
